export default __webpack_public_path__ + "static/generative-border-colors-dark-f4ffc14fe68eb55f26669a639c029137.png";